// extracted by mini-css-extract-plugin
module.exports = {"root":"Hero_root__9k5Uz","title":"Hero_title__ccsL0","text":"Hero_text__YGuYF","button":"Hero_button__NTLpm"};